import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'; 
import './scholarships.css';
import axiosInstance from "../utils/axiosInstance";
import axios from 'axios'; 

function Scholarships({ user, setUser }) {
    const navigate = useNavigate();
    const [sections, setSections] = useState([]);
    const [query, setQuery] = useState('');
    const [educationLevel, setEducationLevel] = useState('');
    const [gpaLevel, setGpaLevel] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [didLeavePage, setDidLeavePage] = useState(false); 
    const [showAwardDropdown, setShowAwardDropdown] = useState(false);
    const [selectedAwardAmount, setSelectedAwardAmount] = useState('');
    const [selectedAwardAmountLabel, setSelectedAwardAmountLabel] = useState('');
    const [alreadyApplied, setAlreadyApplied] = useState(false);
    const API_URL = process.env.REACT_APP_ENV;

    useEffect(() => {
        axiosInstance.get(`${API_URL}/scholarships`)
            .then(res => setSections(res.data))
            .catch(err => console.error(err));
    }, []);

    const handleInputChange = (e) => setQuery(e.target.value);
    const handleEducationChange = (e) => setEducationLevel(e.target.value);
    const handleGpaChange = (e) => setGpaLevel(e.target.value);

    const handleApply = () => {
        setIsModalOpen(false);
        setDidLeavePage(true); 
    }

   const handleApplication = async () => {
        const scholarship_id = selectedDetails.id;
        try {
            await axiosInstance.post(`${API_URL}/apply?scholarship_id=${scholarship_id}`, {});
        alert("Applied successfully!");
        navigate('/application-confirmation');
        } catch (error) {
            console.error("Apply error:", error.response?.data || error.message);
            if (
                error.response &&
                error.response.status === 400 &&
                error.response.data?.detail?.toLowerCase().includes("already applied")
            ) {
            setAlreadyApplied(true);
            } else {
                alert("There was an error applying.");
            }
        }
    };

    const leaveApply = () => {
        setIsModalOpen(true);
        setDidLeavePage(false); 
    }

    const handleAwardSelect = (value, label) => {
        setSelectedAwardAmount(value);
        setSelectedAwardAmountLabel(label);
        setShowAwardDropdown(false);
      };
    const fetchScholarshipDetails = async (id) => {
        try {
            const res = await axiosInstance.get(`${API_URL}/scholarship/${id}`);
            setSelectedDetails(res.data);
            setIsModalOpen(true);  
        } catch (err) {
            console.error("Failed to fetch details:", err.response?.data || err.message);
        }
    };

    const closeModal = () => {
        setSelectedDetails(null);
        setIsModalOpen(false);  
    };

    const amountOptions = [
        { label: "$0 - $1,000", value: "0-1000" },
        { label: "$1,001 - $5,000", value: "1001-5000" },
        { label: "$5,001 - $10,000", value: "5001-10000" },
        { label: "$10,001+", value: "10001+" },
        { label: "All", value: "all" }
    ];

    const filteredScholarships = sections.filter((section) => {
        const matchesQuery =
            section.title.toLowerCase().includes(query.toLowerCase()) ||
            section.description.toLowerCase().includes(query.toLowerCase());

        const matchesEducation =
            educationLevel.toLowerCase() === "" || educationLevel.toLowerCase() === "all" ||
            section.education_level.toLowerCase() === educationLevel.toLowerCase() ||
            (section.education_level.toLowerCase() === "medical school" && educationLevel.toLowerCase() === "medical-school");

        const matchesGPA = (() => {
            if (gpaLevel === "") return true;
            if (gpaLevel === "all") return true;
            const gpa = parseFloat(section.gpa);
            if (gpaLevel === "3.0-3.5") return gpa >= 3.0 && gpa <= 3.5;
            if (gpaLevel === "3.51-4.0") return gpa > 3.5 && gpa <= 4.0;
            return true;
        })();

        const matchesAmount = (() => {
            if (!selectedAwardAmount || selectedAwardAmount === "" || selectedAwardAmount === "all") return true;
            const amount = parseFloat(section.award_amount.replace(/[^0-9.-]+/g,""));
            switch (selectedAwardAmount) {
                case 'under1000':
                    return amount > 0 && amount <= 1000;
                case '1000to5000':
                    return amount > 1000 && amount <= 5000;
                case 'above5000':
                    return amount > 5000;
                default:
                    return true;
            }
        })();

        return matchesQuery && matchesEducation && matchesGPA && matchesAmount;
    });

    return (
        <div className={`scholarships-container ${isModalOpen ? 'modal-open' : ''} ${didLeavePage ? 'leave-page' : ''}`}>
            <div className='scholarships-content'>
                <div className='scholarships-header'>
                    <h1>Scholarships</h1>
                </div>

                <div className='search-row'>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={query}
                        onChange={handleInputChange}
                    />
                    <select value={educationLevel} onChange={handleEducationChange}>
                        <option value=" " disabled>Education Level</option>
                        <option value="All">All</option>
                        <option value="Undergraduate">Undergraduate</option>
                        <option value="Medical-School">Medical School</option>
                    </select>

                    <div className="filter">
                        <div className="custom-dropdown">
                            <div
                                className="custom-dropdown-selected"
                                onClick={() => setShowAwardDropdown(!showAwardDropdown)}
                            >
                                {selectedAwardAmountLabel || 'Award Amount'}
                                <span className="dropdown-arrow">&#9662;</span>
                            </div>
                            {showAwardDropdown &&  (
                            <div className="custom-dropdown-options">
                                <div value={selectedAwardAmount} onClick={() => handleAwardSelect('', 'All')}>All</div>
                                <div value={selectedAwardAmount} onClick={() => handleAwardSelect('under1000', 'Under $1,000')}>Under $1,000</div>
                                <div value={selectedAwardAmount} onClick={() => handleAwardSelect('1000to5000', '$1,000 - $5,000')}>$1,000 - $5,000</div>
                                <div value={selectedAwardAmount} onClick={() => handleAwardSelect('above5000', 'Above $5,000')}>Above $5,000</div>
                            </div>
                            )}
                        </div>
                    </div>


                    <select value={gpaLevel} onChange={handleGpaChange}>
                        <option value=" " disabled>GPA</option>
                        <option value="all">All</option>
                        <option value="3.0-3.5">3.0 - 3.5</option>
                        <option value="3.51-4.0">3.51 - 4.0</option>
                    </select>
                </div>
                {!selectedDetails && (
                <div className='scholarship-cards'>
                    {filteredScholarships.map((section) => (
                        <div className='scholarship-card' key={section.id}>
                            <div className='scholarship-card-content'>
                                <h2>{section.title}</h2>
                                <p><strong>Description: </strong>{section.description}</p>
                                <p><strong>Education Level: </strong>{section.education_level}</p>
                                <p><strong>GPA Requirement: </strong>{section.gpa}</p>
                                <p><strong>Award Amount: </strong>{section.award_amount}</p>
                            </div>
                            <div className='scholarship-home-buttons'>
                                <button className='btn' onClick={() => fetchScholarshipDetails(section.id)}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                )}
                {selectedDetails && (
                    <div className="scholarship-details-modal">
                        <div className="modal-content">
                            <h2>{selectedDetails.brief.title}</h2>
                            <p><strong>Description:</strong> {selectedDetails.description}</p>
                            <p><strong>Eligibility:</strong> 
                            <ul>
                                {selectedDetails.eligibility.split(';').map((item, index) => (
                                <li key={index}>{item}</li>
                                ))}
                            </ul>
                            </p>
                            <p><strong>GPA:</strong> {selectedDetails.brief.gpa}</p>
                            <p><strong>Award Amount:</strong> {selectedDetails.brief.award_amount}</p>
                            <p><strong>Deadline:</strong> {new Date(selectedDetails.deadline).toLocaleDateString()}</p>
                            <div className='scholarship-button-row'>
                            <a href={selectedDetails.apply_url} target="_blank" rel="noopener noreferrer">
                                <button className="apply-btn" onClick={handleApply}>Apply</button>
                            </a>

                            <button className="close-btn" onClick={closeModal}>Close</button>
                            </div>
                        </div>
                    </div>
            )}
            {didLeavePage && <div className="modal-overlay"></div>}
            {didLeavePage && (
                    <div className="application-checker-modal">
                        <div className="application-checker-content">
                            <h2>{selectedDetails.brief.title}</h2>
                            <h3>Did You Apply For This Scholarship?</h3>
                            <p>Selecting 'Yes' will add the scholarship to your application history.</p>
                            <div className='application-checker-row'>
                                <button className="yes-btn" onClick={handleApplication} >Yes</button> 

                                <button className="no-btn" onClick={leaveApply}>No</button>
                            </div>
                        </div>
                    </div>
            )}
            {alreadyApplied && (
                <div className="already-applied-modal">
                    <div className="already-applied-content">
                        <h2>{selectedDetails?.brief?.title}</h2>
                        <h3>You've already applied</h3>
                        <p>You’ve already applied for this scholarship. Check your applications for updates.</p>
                        <div className="already-applied-row">
                            <button className="no-btn" onClick={() => {setAlreadyApplied(false); leaveApply();}}>Close</button>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>
    );
};

export default Scholarships;
